import { useAuthStore } from '~/store/auth/state'

export default defineNuxtPlugin((nuxtApp) => {
  const store = useAuthStore()
  const app = nuxtApp
  const initialLogin = async () => {
    if (checkCookie()) {
      if (!store.getAuthUser) {
        try {
          await setAxiosHeader(getCookie())
          const { data } = await getCurrentUser()
          await setAuthUser(data)
          await app.$nuxtElevio.initElevio()
          await setKbToken()
        } catch (error) {
          console.error(error)
          return false
        }
        return true
      } else {
        return true
      }
    }
  }
  const login = async (email, password) => {
    const { data } = await app.$axios.post(
      `/auth/login`,
      {
        email,
        password,
      },
      {
        withCredentials: true,
      }
    )
    document.cookie = `tenantName=${data.tenant}`
    setCookie(`${data.token_type} ${data.access_token}`, data.expires_in)
    setAxiosHeader(`${data.token_type} ${data.access_token}`)

    const response = await getCurrentUser()
    setAuthUser(response.data)
    await setKbToken()
    await app.$nuxtElevio.initElevio()
    return response
  }
  const logout = async () => {
    await app.$axios.post(`/auth/logout`, {
      withCredentials: true,
    })
    clearAuthData()
    setAxiosHeader(null)
    setKbToken(true)
    clearCookie()
    setTimeout(() => {
      app.$nuxtElevio.logoutElevio()
      app.$nuxtElevio.close()
    }, 1000)
    if (
      app.$config.public.legacyPortalUrl &&
      !(
        app.$config.public.appENV === 'localhost' ||
        app.$config.public.appENV === 'development'
      )
    ) {
      window.location.href = `${app.$config.public.legacyPortalUrl}`
    } else {
      app.$router.replace('/login')
    }
  }
  const setCookie = (token, expiresIn) => {
    document.cookie = `auth=${token};`
  }
  const clearCookie = () => {
    // to remove auth cookie from top level domain and key
    document.cookie = `auth=; path=/; domain=${app.$config.public.appDomain}; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0`
    document.cookie = `tenantName=; path=/; domain=${app.$config.public.appDomain}; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0`
    // to remove auth cookie from sub domain and key
    document.cookie = 'auth=; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0'
    document.cookie =
      'tenantName=; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0'
  }
  const clearAuthData = () => {
    store.setAuthUser(null)
  }
  const setAxiosHeader = (token) => {
    if (token) app.$axios.defaults.headers.Authorization = token
  }
  const getCurrentUser = () => {
    return app.$axios.get(`/me`, {
      withCredentials: true,
    })
  }
  const setAuthUser = (user) => {
    store.setAuthUser(user)
  }
  const checkCookie = () => {
    return (getCookie() && true) || false
  }
  const getCookie = () => {
    const auth = document.cookie.match(
      new RegExp('(^| )' + 'auth' + '=([^;]+)')
    )
    return auth && auth[2] ? decodeURIComponent(auth[2]) : false
  }
  const getTenantName = () => {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith('tenantName='))
      ?.split('=')[1]
  }
  const setKbToken = async (clear = false) => {
    if (!clear) {
      const kbToken = await app.$axios.get(`/sso/kb/token`)
      store.setKbToken(kbToken)
    } else {
      store.setKbToken(null)
    }
  }
  const refreshUserData = async () => {
    const { data } = await getCurrentUser()
    await setAuthUser(data)
  }

  const updateAccount = async (form) => {
    const { data } = await app.$axios.patch(`/me`, form)
    const response = await getCurrentUser()
    setAuthUser(response.data)
    return data
  }

  return {
    provide: {
      auth: {
        initialLogin,
        login,
        logout,
        setCookie,
        clearCookie,
        clearAuthData,
        setAxiosHeader,
        refreshUserData,
        setAuthUser,
        checkCookie,
        getCookie,
        getTenantName,
        setKbToken,
        getCurrentUser,
        updateAccount,
      },
    },
  }
})
